import React from 'react'
import { Button, ReloadIcon } from '@diversioteam/diversio-ds'

import { useGetPulseSurveysTemplatesInfinite } from 'hooks/pulseSurveys/useGetPulseSurveysTemplatesInfinite'
import { TemplateItemSkeleton } from 'containers/PulseSurveys/TemplateItem/skeleton'
import { TemplateItem } from 'containers/PulseSurveys/TemplateItem'
import { PulseSurveysError } from 'containers/PulseSurveys/Error'

import { useTemplates } from './../hooks/useTemplates'
import * as S from './list.styles'

export const List = () => {
    const { debouncedSearchValue, selectedTemplateTypes } = useTemplates()

    const { data, isLoading, fetchNextPage, isFetchingNextPage, isError } = useGetPulseSurveysTemplatesInfinite({
        page_size: 12,
        search: debouncedSearchValue,
        template_type: selectedTemplateTypes[0]?.value || 'all',
    })

    const templates = data?.pages

    const hasNextPage = (() => {
        if (!templates) {
            return false
        }

        const lastPage = templates[templates.length - 1]

        const { page, page_size, total } = lastPage

        return page_size * page < total
    })()

    const handleClickLoadMore = () => {
        fetchNextPage()
    }

    if (isError) {
        return <PulseSurveysError />
    }

    const renderContent = () => {
        if (templates?.[0].count === 0) {
            return <S.NoResults />
        }

        return (
            <>
                <S.List>
                    {isLoading && new Array(12).fill('').map((_, index) => <TemplateItemSkeleton key={index} />)}

                    {templates?.flatMap(({ items }) =>
                        items.map((props) => <TemplateItem key={props.uuid} {...props} />),
                    )}
                </S.List>

                {hasNextPage && (
                    <S.LoadMore>
                        <Button
                            rightIcon={<ReloadIcon type="line" />}
                            type="button"
                            color="primaryLight"
                            onClick={handleClickLoadMore}
                            loading={isFetchingNextPage}
                        >
                            Load More
                        </Button>
                    </S.LoadMore>
                )}
            </>
        )
    }

    return <S.ListWrapper>{renderContent()}</S.ListWrapper>
}
